import angular from 'angular';
import Defaults from '~/scripts/constants/defaults';

/* globals Knitiv */

export default class KformToolbarController {
	#$copyToClipboard;

	#$filter;

	#$rootScope;

	#$translate;

	/** @type {boolean} */
	#validAttribut = true;

	/** @type {boolean} */
	#validForm = true;

	/** @type {boolean} */
	#validRights = true;

	/** @type {boolean} */
	#validRepre = true;

	/** @type {boolean} */
	#validWF = true;

	/* @ngInject */
	/**
	 * @param {any} $copyToClipboard
	 * @param {import('angular').IFilterService} $filter
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('~/scripts/services/model/user').UserModel} User
	 */
	constructor(
		$copyToClipboard,
		$filter,
		$rootScope,
		$translate,
		User,
	) {
		this.Defaults = Defaults;

		this.#$copyToClipboard = $copyToClipboard;
		this.#$filter = $filter;
		this.#$rootScope = $rootScope;
		this.#$translate = $translate;

		this.admin = false;

		this.db = $rootScope.context?.db;

		/** @type {import('~/scripts/services/model/form').default | undefined} */
		this.form = undefined;

		this.hasCreatePermissions = $rootScope.hasCreatePermissions;

		/** @type {boolean} */
		this.isAdmin = !!User.getProfil().admin;

		/** @type {?import('../kform.controller').default} */
		this.kform = null;

		/** @type {?import('@knitiv/api-client-javascript').KNode} */
		this.kid = null;

		/** @type {?import('~/components/list/preview/list-preview.controller').default} */
		this.listPreview = null;

		this.validFile = false;
	}

	/**
	 * @returns {boolean}
	 */
	check() {
		if (!this.kid) {
			return false;
		}
		const files = this.kform?.files[this.kid];
		this.#validAttribut = (
			(this.form?.params.editableTabAttribut && (this.form.formAttribut?.$valid ?? true))
			|| !this.form?.params.editableTabAttribut
		) ?? true;

		this.validFile = (
			(
				this.form?.params.editableTabFile
				&& this.kid
				&& (
					(
						this.form.params.forceUploadFile
						&& (files && files.length > 0)
					)
					|| !this.form?.params.forceUploadFile
				)
			)
			|| !this.form?.params.editableTabFile
		) ?? true;

		this.#validForm = (
			(this.form?.params.editableTabForm && (this.form.formio?.kformForm?.$valid ?? true))
			|| !this.form?.params.editableTabForm
		) ?? true;

		this.#validRepre = (
			(this.form?.params.editableTabRepre && (this.form.formRepre?.$valid ?? true))
			|| !this.form?.params.editableTabRepre
		) ?? true;

		this.#validRights = (
			(this.form?.params.editableTabRights && (this.form.formRights?.$valid ?? true))
			|| !this.form?.params.editableTabRights
		) ?? true;

		this.#validWF = (
			(this.form?.params.editableTabWF && (this.form.formWF?.$valid ?? true))
			|| !this.form?.params.editableTabWF
		) ?? true;

		return this.#validAttribut
			&& this.validFile
			&& this.#validForm
			&& this.#validRepre
			&& this.#validRights
			&& this.#validWF;
	}

	debugError() {
		if (!this.kid) {
			return false;
		}
		const files = this.kform?.files[this.kid];
		const debug = {
			form:  this.form,
			file:  {
				forceUploadFile: this.form?.params.forceUploadFile,
				length:          this.kid && files?.length,
			},
			kid:   this.kid,
			error: {
				attribut: this.form?.formAttribut?.$error,
				form:     this.form?.formio?.kformForm?.$error,
				repre:    this.form?.formRepre?.$error,
				rights:   this.form?.formRights?.$error,
				wf:       this.form?.formWF?.$error,
			},
			valid: {
				attribut: this.#validAttribut,
				file:     this.validFile,
				form:     this.#validForm,
				repre:    this.#validRepre,
				rights:   this.#validRights,
				wf:       this.#validWF,
			},
		};

		// eslint-disable-next-line no-console
		console.log(debug);
		this.#$copyToClipboard(angular.toJson(debug, true), false);
	}

	/**
	 * @returns {boolean}
	 */
	isSubmitEnabled() {
		const loading = this.kform?.loading ?? false;
		const dirtyAttribut = this.form?.params.editableTabAttribut && this.form.formAttribut?.$dirty;
		const dirtyForm = this.form?.params.editableTabForm && this.form.formio?.kformForm?.$dirty;
		const dirtyRepre = this.form?.params.editableTabRepre && this.form.formRepre?.$dirty;
		const dirtyRights = this.form?.params.editableTabRights && this.form.formRights?.$dirty;
		const dirtyWF = (this.form?.params.editableTabWF && this.form.formWF?.$dirty) ?? false;

		return !loading && this.check() && (dirtyAttribut || dirtyForm || dirtyRepre || dirtyRights || dirtyWF);
	}

	/**
	 * @param {import('angular').IOnChangesObject} changes
	 */
	$onChanges(changes) {
		if (changes.kid) {
			this.form = this.kid ? this.kform?.forms[this.kid] : undefined;
		}
	}

	$onInit() {
		this.admin = this.#$rootScope.hasCreatePermissions || this.#$rootScope.context?.profil.admin === 1;
		this.hasCreatePermissions = this.form?.isa.kright !== undefined
			&& (this.form.isa.kright & Defaults.DROIT.CREATE) > 0;
	}
}
